import React from 'react';
import { UsersIcon } from 'lucide-react';
import type { Team, MetricType, PeriodInfo } from '../../types';
import { ProgressBar } from '../ui/ProgressBar';
import { Badge } from '../ui/Badge';
import { LoanOfficerRow } from './LoanOfficerRow';
import { aggregateTeamMetrics, getProgressPercentage, getProgressStatus, calculateProjection } from '../../utils/calculations';
interface TeamSectionProps {
  team: Team;
  period: PeriodInfo;
  metric: MetricType;
}
export function TeamSection({
  team,
  period,
  metric
}: TeamSectionProps) {
  const {
    current,
    goal
  } = aggregateTeamMetrics(team, metric);
  const percentage = getProgressPercentage(current, goal);
  const projected = calculateProjection(current, period.daysElapsed, period.totalDays);
  const projPct = getProgressPercentage(projected, goal);
  const status = getProgressStatus(projPct);
  return <div className="ml-4 border-l-2 border-gray-200 dark:border-gray-600 pl-4 mb-4 last:mb-0" data-id="element-107">
      {/* Team Header */}
      <div className="flex items-center gap-4 py-3 px-4 bg-gray-50 dark:bg-gray-700/50 rounded-lg mb-2" data-id="element-108">
        <div className="flex items-center gap-3 w-44 flex-shrink-0" data-id="element-109">
          <div className="w-8 h-8 rounded-full bg-blue-100 dark:bg-blue-900/50 flex items-center justify-center flex-shrink-0" data-id="element-110">
            <UsersIcon className="w-4 h-4 text-blue-600 dark:text-blue-400" data-id="element-111" />
          </div>
          <div className="min-w-0" data-id="element-112">
            <p className="text-sm font-semibold text-gray-900 dark:text-white truncate" data-id="element-113">
              {team.name}
            </p>
            <p className="text-xs text-gray-500 dark:text-gray-400 truncate" data-id="element-114">
              {team.managerName}
            </p>
          </div>
        </div>

        <div className="flex-1 min-w-0" data-id="element-115">
          <ProgressBar current={current} goal={goal} size="sm" showLabel={false} data-id="element-116" />
        </div>

        <div className="w-24 text-right flex-shrink-0" data-id="element-117">
          <span className="text-sm font-semibold text-gray-900 dark:text-white" data-id="element-118">
            {current}
          </span>
          <span className="text-sm text-gray-400 dark:text-gray-500" data-id="element-119">
            {' '}
            / {goal}
          </span>
        </div>

        <div className="w-16 text-right flex-shrink-0" data-id="element-120">
          <span className="text-sm font-medium text-gray-700 dark:text-gray-300" data-id="element-121">
            {percentage}%
          </span>
        </div>

        <div className="w-24 flex-shrink-0 flex justify-end" data-id="element-122">
          <Badge status={status} size="sm" data-id="element-123" />
        </div>
      </div>

      {/* Loan Officers */}
      <div className="bg-white dark:bg-gray-800 rounded-lg border border-gray-100 dark:border-gray-700 overflow-hidden shadow-sm" data-id="element-124">
        {team.loanOfficers.map(lo => <LoanOfficerRow key={lo.id} loanOfficer={lo} period={period} metric={metric} data-id="element-125" />)}
      </div>
    </div>;
}